module.exports = __webpack_public_path__ + "static/img/5.640c984.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/5.png
// module id = r9UA
// module chunks = 0